import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Divider, Icon, Input, message, Modal, Row, Select, Tag } from 'antd';
import TableCommon from '../../components/common/table/TableCommon';
import { currencyVND, dateToString } from '../../utils';
import * as CommonService from '../../services/CommonService';
import { INVENTORY_REPORT, INVOICE_ENDPOINT, INVOICE_REPORT } from '../../services/endpoint';
import { ORDER_STATUS } from '../../utils/const';
import './style.scss';
import { useHistory } from 'react-router-dom';
import { QuickPaymentForm } from '../../components/common/quick-payment';
import moment from 'moment/moment';

const { Option } = Select;

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 20
};

export default () => {

	const [ds, setDs] = useState([]);
	const [searchValues, setSearchValues] = useState({});
	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});
	const [selectedRow, setSelectedRow] = useState([]);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [showQuickPayment, setShowQuickPayment] = useState(false);
	const [reportDate, setReportDate] = useState(['', '']);

	const history = useHistory();

	useEffect(() => {
		window.setLoading(true);
		CommonService.get(INVOICE_ENDPOINT, {
			page: page.currentPage - 1,
			size: page.perpage
		}).then(res => {
			setDs(res.data?.contents);
			setPage({ ...page, total: res.data?.totalElements });
		}).catch(error => {
			message.error(error?.data?.message);
		}).finally(() => window.setLoading(false));
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(INVOICE_ENDPOINT, param);
		setDs(resp.data?.contents);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		// {
		// 	title: 'STT',
		// 	dataIndex: 'index',
		// 	width: 50,
		// 	align: 'center',
		// 	render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		// },
		{
			title: 'Mã đơn hàng',
			dataIndex: 'invoiceCode',
			align: 'center',
			width: 80,
			render: (text, record) => {
				return <Button style={{ padding: '0', textWrap: 'wrap' }} type={'link'}
											 onClick={() => gotoDetail(record.id)}>{text}</Button>;
			}
		},
		{
			title: 'Ngày tạo đơn',
			dataIndex: 'createDate',
			width: 130,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		},
		{
			title: 'Tên khách hàng',
			dataIndex: 'customerName',
			className: 'header-center-align',
			width: 200
		},
		// {
		// 	title: 'Loại đơn hàng',
		// 	dataIndex: 'paid',
		// 	width: 100,
		// 	align: 'center',
		// 	render: (paid) => paid ? <Tag color={'rgb(83, 100, 254)'}>Đặt hàng</Tag> : <Tag color={'#fe5369de'}>Trả hàng</Tag>
		// },
		{
			title: 'Trạng thái đơn hàng',
			dataIndex: 'status',
			align: 'center',
			className: 'header-center-align',
			width: 85,
			render: (status) => {
				const statusInfo = ORDER_STATUS.find(item => item.value === status);
				return statusInfo ? <Tag style={{ width: '85px' }} color={statusInfo.color}>{statusInfo.name}</Tag> : null;
			}
		},
		{
			title: 'Giá trị đơn hàng',
			dataIndex: 'finalAmount',
			width: 120,
			align: 'center',
			render: (el) => <>{currencyVND(el)}</>
		}
	];

	const handleChange = (value, key) => {
		searchValues[key] = value;
		setSearchValues({ ...searchValues });
	};

	const goToCreate = () => {
		history.push('/create-orders');
	};

	const gotoDetail = (id) => {
		history.push('/orders/' + id);
	};


	const onEnter = (evt) => {
		if (evt.key === 'Enter') {
			onSearch(DEFAULT_PAGE);
		}
	};

	const handleQuickPayment = () => {
		CommonService.post(`${INVOICE_ENDPOINT}/payment`, selectedRow.filter(el => el.status === 'PROCESSING').map(el => el.id)).then(res => {
			if (res.status === 200) {
				message.success('Thanh toán thành công');
				onSearch(DEFAULT_PAGE);
				setSelectedRow([])
				setSelectedRowKeys([]);
				setShowQuickPayment(false);
			}
		}).catch(error => {
			message.error(error?.data?.message || 'Có lỗi xảy ra');
		});
	};

	const handleShowModalQuickPayment = () => {
		if (selectedRow.filter(el => el.status === 'PROCESSING').length > 0) {
			setShowQuickPayment(true);
		} else {
			message.error('Vui lòng chọn đơn hàng đủ điều kiện và chưa thanh toán hết!');
		}
	};

	const renderHeader = () => {
		return <div>
			<span>{`Đã chọn ${selectedRow.length} đơn hàng`}</span>
			{selectedRow.length > 0 &&
				<>
					<Button type={'link'} style={{ height: '80%' }} onClick={handleShowModalQuickPayment}>Thanh toán
						nhanh</Button>
				</>
			}
		</div>;
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: (selectedRowKeys, selectedRows) => {
			setSelectedRow(selectedRows);
			setSelectedRowKeys(selectedRowKeys);
		}
	};

	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleExport = async () => {
		setIsModalOpen(false);
		try {
			window.setLoading(true);
			const response = await CommonService.post(
				`${INVOICE_REPORT}?from=${reportDate[0]}&to=${reportDate[1]}`,
				{to: reportDate[0], from: reportDate[1]},
				{ responseType: 'blob' }
			);

			const blob = new Blob([response], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});

			// Tạo link download
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = `danh_sach_don_hang_${moment().format('yyyy_MM_dd_HH_mm_ss')}.xlsx`;
			document.body.appendChild(a);
			a.click();
			a.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Lỗi khi export file Excel:', error);
			message.error('Xuất file thất bại');
		} finally {
			window.setLoading(false);
		}
	};

	return (<Fragment>
			<Row className="mb-10" id={'product__action'}>
				<Col style={{visibility: 'visible'}}>
					<div>
						<Divider type="vertical" />
						<Icon type="download" />
						<span style={{ color: '#000000d9', margin: '0 5px', cursor: 'pointer' }} onClick={() => setIsModalOpen(true)}>Xuất file</span>
						{/*<Divider type="vertical" />*/}
						{/*<Icon type="upload" />*/}
						{/*<span style={{ color: '#000000d9', margin: '0 5px' }} onClick={() => alert('Nhập file')}>Nhập file</span>*/}
					</div>
				</Col>
				<Col>
					<Button type="primary" style={{ width: '150px' }} id={'btn-create-product'} icon="plus"
									onClick={goToCreate}>Tạo đơn</Button>
				</Col>
			</Row>
			<Row>
				<div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
					<Input
						style={{ height: '32px' }}
						placeholder="Tìm kiếm theo mã đơn hàng, IMEI, SĐT"
						allowClear
						onChange={(value) => handleChange(value.target.value, 'param')}
						onKeyDown={onEnter}
					/>
					<Select
						mode="multiple"
						placeholder="Trạng thái đơn hàng"
						onChange={(value) => handleChange(value, 'status')}
						style={{ width: '35%' }}
						allowClear
						maxTagCount={1}
						maxTagTextLength={10}
					>
						{ORDER_STATUS.map(el => (<Option key={el.value}>{el.name}</Option>))}
					</Select>
					<DatePicker.RangePicker
						allowClear
						placeholder={['Từ ngày', 'Đến ngày']}
						style={{ width: '400px' }}
						onChange={(value) => {
							const arr = value.map(el => dateToString(el, 'YYYY-MM-DD'));
							handleChange(arr[0], 'from');
							handleChange(arr[1], 'to');
						}} />
					<Button type="primary"
									style={{ width: '150px' }}
									onClick={() => onSearch(DEFAULT_PAGE)}>
						Tìm kiếm
					</Button>
				</div>
			</Row>
			<TableCommon bordered={true}
									 title={renderHeader}
									 page={page}
									 setPage={setPage}
									 datasource={ds}
									 columns={columns}
									 onSearch={onSearch}
									 rowSelection={rowSelection}
			/>
			<QuickPaymentForm handlePayment={handleQuickPayment}
												filterStatus={'PROCESSING'}
												selectedRow={selectedRow}
												show={showQuickPayment}
												onCancel={() => setShowQuickPayment(false)}
												warningMsg={<i>Lưu ý: Hệ thống sẽ thanh toán lần lượt các đơn và tạo ra nhiều phiếu thu tương
													ứng với số lượng đơn hàng cần thanh toán.</i>}
			/>
			<Modal
				title="Xuất file"
				visible={isModalOpen}
				onOk={handleExport}
				onCancel={() => setIsModalOpen(false)}
			>
				Chọn thời gian:
				<DatePicker.RangePicker
					allowClear
					placeholder={['Từ ngày', 'Đến ngày']}
					style={{ width: '100%', marginTop: '10px' }}
					onChange={(value) => {
						const arr = value.map(el => dateToString(el, 'YYYY-MM-DD'));
						setReportDate([...arr])
					}} />
			</Modal>
		</Fragment>

	);
};
